module.exports = "/img/user-guided-tours/tags-usage/or.png?e7f5b8df52c08b6588a9f650a73dec9a";